import React from "react";

const Arrow = ({ style }) => (
  <div style={{ ...style }}>
    &gt;
  </div>
);

export default Arrow;
